import { ShefStatus } from 'src/gqlReactTypings.generated.d';

export const canSeeDashboard = (status: ShefStatus) => [ShefStatus.Approved, ShefStatus.Unapproved].includes(status);

export const canSeeFullDashboard = (status: ShefStatus) => [ShefStatus.Approved].includes(status);

export const canSeeAvailability = (status: ShefStatus) => [ShefStatus.Approved].includes(status);

export const canSeeOrders = (status: ShefStatus) => [ShefStatus.Approved].includes(status);

export const canSeeApplication = (status: ShefStatus) => [ShefStatus.Applicant].includes(status);

export const canSeeRatings = (status: ShefStatus) => [ShefStatus.Approved].includes(status);

export const canSeeEarnings = (status: ShefStatus) => [ShefStatus.Approved, ShefStatus.Unapproved].includes(status);

export const canSeeInsights = (status: ShefStatus) => [ShefStatus.Approved, ShefStatus.Unapproved].includes(status);
export const canSeePromoteYourself = (status: ShefStatus) => [ShefStatus.Approved].includes(status);

export const canSeeQRScanner = (status: ShefStatus) => [ShefStatus.Approved, ShefStatus.Unapproved].includes(status);
